export const COM_SPEC_ONLY = "COM Spec Only";
export const ALL_INCLUSIVE = "All Inclusive";
export const SPEC_ONLY = "Spec Only";
